

















































import { Component, Vue } from "vue-property-decorator";
import CPage from "@/components/form/CustomPage/CPage.vue";
import { getCurrentCompanyId } from "@/plugins/roles";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import ExportTable from "@/components/export/ExportTable.vue";
import { Export as IExport } from "@/api-v2/import-export-2/models/export";
import { Info as IInfo } from "@/api-v2/import-export-2/models/info";
import { ExportListParams } from "@/getinfo-api/exports";
import { ImportExport } from "@/classes/importExport/ImportExport";
import CField from "@/components/form/CField.vue";

@Component({
  components: { CField, ExportTable, CBlock, CPage }
})
export default class ExportList extends Vue {
  exports: IExport[] = [];
  count: number = 0;
  types: IInfo[] = [];
  isLoading: boolean = false;
  pageNumber = 1;
  params: ExportListParams = {
    companyId: this.companyId,
    type: "labor_protection_education_protocol_export",
    order: "DESC",
    sort: "createdAt",
    offset: 0,
    limit: 30
  };

  get companyId() {
    return getCurrentCompanyId();
  }

  async getTypes() {
    try {
      this.isLoading = true;
      this.types = await ImportExport.getExportTypes();
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    } finally {
      this.isLoading = false;
    }
  }

  changePage() {
    this.$nextTick(() => {
      this.params.offset = this.params.limit! * (this.pageNumber - 1);
      this.getList();
    });
  }

  applyFilter() {
    this.pageNumber = 1;

    this.getList();
  }

  clearFilter() {
    this.pageNumber = 1;

    this.params = {
      order: "DESC",
      status: undefined,
      type: "labor_protection_education_protocol_export",
      limit: 30,
      offset: 0
    };
    this.getList();
  }

  async getList() {
    try {
      this.isLoading = true;
      const data = await ImportExport.getExportList(this.params);
      this.exports = data.items;
      this.count = data.count;
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    } finally {
      this.isLoading = false;
    }
  }

  created() {
    this.getList();
    this.getTypes();
  }
}
